 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~f785e966":"default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~f785e966","default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~764f68ef":"default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~764f68ef","case-spectrum-case-spectrum-module":"case-spectrum-case-spectrum-module","default~cases-cases-module~create-new-case-create-new-case-module~report-generation-report-generatio~951be975":"default~cases-cases-module~create-new-case-create-new-case-module~report-generation-report-generatio~951be975","default~cases-cases-module~settings-settings-module":"default~cases-cases-module~settings-settings-module","cases-cases-module":"cases-cases-module","default~create-new-case-create-new-case-module~data-data-module~load-files-load-files-module~setting~5821dd1b":"default~create-new-case-create-new-case-module~data-data-module~load-files-load-files-module~setting~5821dd1b","default~create-new-case-create-new-case-module~data-data-module~settings-settings-module":"default~create-new-case-create-new-case-module~data-data-module~settings-settings-module","default~create-new-case-create-new-case-module~data-data-module~report-generation-report-generation-module":"default~create-new-case-create-new-case-module~data-data-module~report-generation-report-generation-module","default~create-new-case-create-new-case-module~load-files-load-files-module~settings-settings-module":"default~create-new-case-create-new-case-module~load-files-load-files-module~settings-settings-module","default~create-new-case-create-new-case-module~data-data-module":"default~create-new-case-create-new-case-module~data-data-module","create-new-case-create-new-case-module":"create-new-case-create-new-case-module","default~knowledge-base-knowledge-base-module~settings-settings-module~subscription-subscription-module":"default~knowledge-base-knowledge-base-module~settings-settings-module~subscription-subscription-module","common":"common","settings-settings-module":"settings-settings-module","report-generation-report-generation-module":"report-generation-report-generation-module","subscription-subscription-module":"subscription-subscription-module","load-files-load-files-module":"load-files-load-files-module","default~home-home-module~privacy-policy-privacy-policy-module~terms-of-use-terms-of-use-module":"default~home-home-module~privacy-policy-privacy-policy-module~terms-of-use-terms-of-use-module","privacy-policy-privacy-policy-module":"privacy-policy-privacy-policy-module","terms-of-use-terms-of-use-module":"terms-of-use-terms-of-use-module","knowledge-base-knowledge-base-module":"knowledge-base-knowledge-base-module","profile-update-profile-module":"profile-update-profile-module","users-users-module":"users-users-module","qc-results-qc-results-module":"qc-results-qc-results-module"}[chunkId]||chunkId) + "." + {"default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~f785e966":"a5478da1171d39051942","default~case-spectrum-case-spectrum-module~cases-cases-module~create-new-case-create-new-case-module~764f68ef":"7e9d2415f285573bf0f3","case-spectrum-case-spectrum-module":"162270fbe0ad43ef3123","default~cases-cases-module~create-new-case-create-new-case-module~report-generation-report-generatio~951be975":"6bb9955a4ba9d5668378","default~cases-cases-module~settings-settings-module":"0e678d2323165b3f3b3c","cases-cases-module":"68e3442a111c392285a8","default~create-new-case-create-new-case-module~data-data-module~load-files-load-files-module~setting~5821dd1b":"0bbe1b0e99831553aee8","default~create-new-case-create-new-case-module~data-data-module~settings-settings-module":"df916323c2fc105ce267","default~create-new-case-create-new-case-module~data-data-module~report-generation-report-generation-module":"1e097e1db0fc5710b56e","default~create-new-case-create-new-case-module~load-files-load-files-module~settings-settings-module":"8e41ee5a1d565aea2c30","default~create-new-case-create-new-case-module~data-data-module":"db176081c6cac31d40a6","create-new-case-create-new-case-module":"e84459fe9b1e3e2326d4","default~knowledge-base-knowledge-base-module~settings-settings-module~subscription-subscription-module":"7cfe98a2335fdc085955","common":"a240835897205427f6c3","settings-settings-module":"f6a1d387df714b7dea24","report-generation-report-generation-module":"9be454fda7861c351812","subscription-subscription-module":"4c2e692abdc15bfa7a9f","load-files-load-files-module":"c8e53c67dc8c9c0b4246","default~home-home-module~privacy-policy-privacy-policy-module~terms-of-use-terms-of-use-module":"ddf5a8b1b9608457a542","privacy-policy-privacy-policy-module":"b0efaf3f5af1b8265c23","terms-of-use-terms-of-use-module":"5e7b3e18a4f03169b61a","knowledge-base-knowledge-base-module":"77f0011a2922cf6f5c5c","profile-update-profile-module":"8b45388991d666d52873","users-users-module":"79da0a8c2c73206e0bb2","qc-results-qc-results-module":"598c04dd04ef20f48408"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
